<!--
     <StateInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - items → [[value, text], [1, 'User 1']]
     - value
     - label
     - placeholder
     - multiple
-->

<template>
  <AutocompleteSelect
    :props="props"
    @update="update"
   ></AutocompleteSelect>
</template>

<script>

import AutocompleteSelect from '@/components/inputs/AutocompleteSelect'


export default {
    name: 'StateInput',
  
  components: {
    AutocompleteSelect,    
   },


  props: ['props'],

  data: () => ({
    valid: true,
  }),

  computed: {
    value() {
      let r = this.props.value || null
      if (
        this.props.value &&
        this.props.multiple &&
        this.props.value.length < 1
      ) {
        r = null
      }
      return r
    },
    rules() {
      // TODO: Multilang: Change hardcoded string
      return [(value) => !!value || !this.props.required || this.$vuetify.lang.translator('required_field')]
    },
  },

  methods: {
    validate() {
      // TODO: Show error message
      return this.valid
    },
    error_state(ok) {
      this.valid = ok
    },
    update(value) {
      this.$emit('update',value);
    },
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>
